export const DATA_HOOKS = {
  colorPickerItem: 'color-picker-item',
  colorPickerItemTooltip: 'color-picker-item-tooltip',
  colorPickerItemDataCrossed: 'data-crossed',
  colorPickerItemChecked: 'data-color-picker-item-checked',
  colorPickerFieldsetLabel: 'color-picker-fieldset-label',
  colorPickerLabelAsterisk: 'color-picker-label-asterisk',
  colorPickerSuffix: 'color-picker-suffix',
  colorPickerLoader: 'color-picker-loader',
};
